import { render } from "./NotificationMedia.vue?vue&type=template&id=06bca564"
import script from "./NotificationMedia.vue?vue&type=script&lang=js"
export * from "./NotificationMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__